const ORDERS = {
  GETTING_ORDER_BY_ID: 'GETTING_ORDER_BY_ID',
  GET_ORDER_BY_ID_SUCCESS: 'GET_ORDER_BY_ID_SUCCESS',
  GET_ORDER_BY_ID_FAILURE: 'GET_ORDER_BY_ID_FAILURE',
  CLEAR_ORDER_DETAILS: 'CLEAR_ORDER_DETAILS',

//   NOTE :: Added Constant for now after OrderV2 Release
  UPDATING_ORDER_METADATA: 'UPDATING_ORDER_METADATA',
  UPDATE_ORDER_METADATA_SUCCESS: 'UPDATE_ORDER_METADATA_SUCCESS',
  UPDATE_ORDER_METADATA_FAILURE: 'UPDATE_ORDER_METADATA_FAILURE',

  FAILING_ORDER: 'FAILING_ORDER',
  FAIL_ORDER_SUCCESS: 'FAIL_ORDER_SUCCESS',
  FAIL_ORDER_FAILURE: 'FAIL_ORDER_FAILURE',

  UPDATE_ORDER_TICKET_DATA: 'UPDATE_ORDER_TICKET_DATA',

  // BBPS Complaints
  GETTING_BBPS_COMPLAINTS: 'GETTING_BBPS_COMPLAINTS',
  GET_BBPS_COMPLAINTS_SUCCESS: 'GET_BBPS_COMPLAINTS_SUCCESS',
  GET_BBPS_COMPLAINTS_FAILURE: 'GET_BBPS_COMPLAINTS_FAILURE',
  
  CREATING_BBPS_COMPLAINT: 'CREATING_BBPS_COMPLAINT',
  CREATE_BBPS_COMPLAINT_SUCCESS: 'CREATE_BBPS_COMPLAINT_SUCCESS',
  CREATE_BBPS_COMPLAINT_FAILURE: 'CREATE_BBPS_COMPLAINT_FAILURE',
  
  UPDATING_BBPS_COMPLAINT: 'UPDATING_BBPS_COMPLAINT',
  UPDATE_BBPS_COMPLAINT_SUCCESS: 'UPDATE_BBPS_COMPLAINT_SUCCESS',
  UPDATE_BBPS_COMPLAINT_FAILURE: 'UPDATE_BBPS_COMPLAINT_FAILURE',
  
  SET_BBPS_SEARCH_ORDER_ID: 'SET_BBPS_SEARCH_ORDER_ID',
  SET_BBPS_CURRENT_ORDER_ID: 'SET_BBPS_CURRENT_ORDER_ID',
  
  CLEAR_BBPS_COMPLAINTS: 'CLEAR_BBPS_COMPLAINTS'
};

export default ORDERS;
